import { UsersModule } from "./../store/modules/UsersModule";
import Vue from "vue";
import VueRouter, { RawLocation, Route, RouteConfig } from "vue-router";
import OperatorView from "@/views/OperatorView.vue";
import NewOperatorView from "@/views/NewOperatorView.vue";
import StationsOverView from "@/views/StationsOverView.vue";
import StationDetailsView from "@/views/StationDetailsView.vue";
import NewStationView from "@/views/NewStationView.vue";
import BookingsView from "@/views/BookingsView.vue";
import AdminView from "@/views/AdminView.vue";
import FirmwareView from "@/views/FirmwareView.vue";
import FirmwareVersionsView from "@/views/FirmwareVersionsView.vue";
import RegistrationView from "@/views/RegistrationView.vue";
import LogView from "@/views/LogView.vue";
import LoginView from "@/views/LoginView.vue";
import PasswordResetView from "@/views/PasswordResetView.vue";
import AccountSettingsView from "@/views/AccountSettingsView.vue";
import CreateBookingView from "@/views/CreateBookingView.vue";
import StationUtilizationView from "@/views/StationUtilizationView.vue";
import { User } from "@/api/dtos/User.schema";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect() {
      return { path: '/station' }
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: {
      allowAnonymous: true,
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: PasswordResetView,
    meta: {
      allowAnonymous: true,
    },
  },
  {
    path: "/operator/new",
    name: "Betreiber anlegen",
    component: NewOperatorView,
  },
  {
    path: "/operator/:operatorUuid",
    name: "Betreiber",
    component: OperatorView,
  },
  {
    path: "/station",
    name: "Stationen",
    component: StationsOverView,
  },
  {
    path: "/station/new",
    name: "Station anlegen",
    component: NewStationView,
    props: (route) => ({ operatorId: route.query.operatorId }),
  },
  {
    path: "/station/:stationUuid",
    name: "Stationsdetails",
    component: StationDetailsView,
  },
  {
    path: "/station/:stationUuid/utilization",
    name: "StationUtilizationView",
    component: StationUtilizationView,
  },
  {
    path: "/booking",
    name: "Buchung",
    component: BookingsView,
  },
  {
    path: "/new-booking",
    name: "Buchung erstellen",
    component: CreateBookingView,
    meta:{fullHeight: true}
  },
  {
    path: "/register/:token",
    name: "Registrierung",
    component: RegistrationView,
    meta: {
      allowAnonymous: true,
    },
  },
  {
    path: "/administration",
    name: "Admin",
    component: AdminView,
    meta: { requiresAdmin: true },
  },
  {
    path: "/firmwares",
    name: "Firmware",
    component: FirmwareView,
    meta: { requiresAdmin: true },
  },
  {
    path: "/firmware/:firmwareId",
    name: "Firmware",
    component: FirmwareVersionsView,
    meta: { requiresAdmin: true },
  },
  {
    path: "/log",
    name: "Log",
    component: LogView,
  },
  {
    path: "/profile",
    name: "Einstellungen",
    component: AccountSettingsView,
  },
  {
    path: "*",
    redirect: { name: "Stationen" },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach(async (to, from, next) => {
  console.log("Navigating to:", to.name, "path:", to.path);

  const user = UsersModule.localUser;

  if (user) {
    // Admin check
    if (to.meta?.requiresAdmin && !user.isAdmin) {
      return next({ name: "Stationen" });
    }
    return next();
  } else {
    if (to.meta?.allowAnonymous) return next();

    await UsersModule.tryResumeSession();

    if (UsersModule.localUser) {
      if (to.meta?.requiresAdmin && !UsersModule.localUser.isAdmin) {
        return next({ name: "Stationen" });
      }
      return next();
    }

    return next({ name: "Login" });
  }
});

// const originalPush = router.push
// router.push = async function push (this: any, location: RawLocation): Promise<Route | void> {
//   try {
//     return await originalPush.call(this, location)
//   } catch (err) {
//     console.log('Error caught')
//     if (err instanceof Error && err.name) {
//       console.log(err.name)
//       if (
//         err.name !== 'NavigationDuplicated'
//       ) {
//         console.error(err)
//       } else {
//         console.log('Caught')
//       }
//     } else {
//       console.error('Unexpected navigation error:', err)
//     }
//     return Promise.reject(err) // Ensure error propagates correctly
//   }
// } as typeof router.push

export default router;
